import Backbone from "backbone";
import $ from "jquery";
import { MagnificPopup } from "../../../Assets/javascripts/common/dynamic-imports/MagnificPopup";
import swfobject from "../../../Assets/javascripts/vendors/swfobject";

export default Backbone.View.extend({

    initialize: function (options) {
      this.popupOpened = this.popupOpened.bind(this);

      this.magnificPopup = new MagnificPopup(this.$el, {
        type: 'inline',
        midClick: true,
        callbacks: {
          open: this.popupOpened.bind(this)
        }
      });
    },

    popupOpened: function () {
      this.$popupContent = this.magnificPopup.instance.content;
      var $popupData = this.$popupContent.find('.js-swf-data');

      if (this.$popupContent.length && $popupData.length) {

        this.swf = {
          url: $popupData.data('url'),
          date: $popupData.data('date'),
          grid: $popupData.data('grid')

        }

        var price = this.$el.closest('.ProductPriceBox-item').data('price');
        this.loadSWFCredit(price);
      }
    },

    replaceSwfWithEmptyDiv: function (targetId) {
      var el = document.getElementById(targetId);
      if (el) {
        var div = document.createElement('div');
        el.parentNode.insertBefore(div, el);

        //Remove the SWF
        swfobject.removeSWF(targetId);

        //Give the new DIV the old element's ID
        div.setAttribute('id', targetId);
      }
    },

    loadSWFCredit: function (amount) {

      //replace object/element with a new div
      var targetId = 'simulateur';
      this.replaceSwfWithEmptyDiv(targetId);

      var flashvars = {
        totalttc: amount,
        date: this.swf.date,
        codecredit: this.$popupContent.find('.js-swf-data').data('credit-code'),
        grille: this.swf.grid
      };

      swfobject.embedSWF(this.swf.url, targetId, '730', '415', '8.0.0', '', flashvars, {
        quality: 'high',
        wmode: 'transparent'
      });

    }

  });
